import { registerReactAsCustomHtmlElementPage } from '@boschebike/ebds-react';
import { Buffer } from 'buffer';
import { App } from './App';
import { injectGlobalPrintStyles } from './helpers/printStyles';

window.Buffer = Buffer;

// Inject print styles into document head (outside shadow DOM)
injectGlobalPrintStyles();

registerReactAsCustomHtmlElementPage('terms-of-use-app', App, {
  shadow: 'open',
  mountPointStyle: 'display: flex;',
});
